"use strict";
var React = require("react");
var ReportsStore = require("../../stores/ReportsStore");
var ReportsActions = require("../../actions/ReportsActions");
var InventoryStore = require("../../stores/InventoryStore");
var InventoryActions = require("../../actions/InventoryActions")
var numberWithCommas = require('../../utils/helpers').numberWithCommas;
var _ = require("underscore");
var clone = require("clone");
var moment = require('moment');
var Link = require('react-router').Link;
var Spinner = require('react-spinkit');
var LineChart = require("react-chartjs").Line;
var DoughnutChart = require("react-chartjs").Doughnut;
var AuthenticationStore = require("../../stores/AuthenticationStore");

var chartOptions = {
  //Boolean - Whether the line is curved between points
  bezierCurve : false,
  //Boolean - Whether to show a dot for each point
  pointDot : true,
  //Number - Radius of each point dot in pixels
  pointDotRadius : 4,
  //Number - Pixel width of point dot stroke
  pointDotStrokeWidth : 1,
  //Number - amount extra to add to the radius to cater for hit detection outside the drawn point
  pointHitDetectionRadius : 20,
  //Boolean - Whether to show a stroke for datasets
  datasetStroke : true,
  //Number - Pixel width of dataset stroke
  datasetStrokeWidth : 2,
};

var Reports = React.createClass({
    getInitialState: function() {
      return {
        reportList: ReportsStore.getState().reportList,
        items: ReportsStore.getState().items,
        fetchingItems: ReportsStore.getState().fetchingItems
      };
    },
    componentWillMount: function() {
      ReportsStore.listen(this.onChange);
    },
    componentDidMount: function() {
      ReportsActions.fetchAllReports();
      ReportsActions.getItems();
    },
    componentWillUnmount: function() {
      ReportsStore.unlisten(this.onChange);
    },
    onChange: function() {
      var newState = {
        reportList: ReportsStore.getState().reportList,
        items: ReportsStore.getState().items,
        fetchingItems: ReportsStore.getState().fetchingItems
      }

      if((!_.isEmpty(newState.reportList) && !_.isEmpty(newState.items))){
        this.setState(newState);
      }
      else {
        this.setState({
          fetchingItems: newState.fetchingItems
        });
      }
    },
    constructChartData: function() {
      var labels = [];
      var data = [];
      var items = clone(this.state.items);
      // Sort items by creation date
      items = _.sortBy(items, 'creation_date');
      var items_grouped = _.groupBy(items, function(obj){
          var date_obj = moment(obj.creation_date).format("D MMM YYYY");
          return date_obj;
      });

      _.map(items_grouped, function(item, key) {
          item.key = key;
          data.push(item.length);
          labels.push(key);
      });
      var data = {
          labels: labels,
          datasets: [{
            label: "Skráning búnaðar",
            fillColor: "rgba(61,151,210,0.2)",
            strokeColor: "rgba(61,151,210,1)",
            pointColor: "rgba(61,151,210,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#fff",
            pointHighlightStroke: "rgba(61,151,210,1)",
            data: data
          }]
      }
      return data;
    },

    constructPieData: function(){
        var color_array = ['#3DD264','#3D97D2','#D0D23D','#D23D3D','#D23DC0','#3D49D2','#D2A43D'];
        var data_dep = [];
        var data_loc = [];
        var data_type = [];
        var items_dep = this.state.reportList.departments;
        var items_loc = this.state.reportList.locations;
        var items_type = this.state.reportList.types;
        var counter_dep = 0;
        var counter_loc = 0;
        var counter_type = 0;

        _.map(items_dep, function(item, key) {
            var item = {
                value: item.number_of_items,
                label: key,
                color: color_array[counter_dep]
            }
            counter_dep++;
            if(counter_dep > color_array.length){
                counter_dep = 0;
            }
            data_dep.push(item);
        });

         _.map(items_loc, function(item, key) {
            var item = {
                value: item.number_of_items,
                label: key,
                color: color_array[counter_loc]
            }
            counter_loc++;
            if(counter_loc > color_array.length) {
                counter_loc = 0;
            }
            data_loc.push(item);
        });

         _.map(items_type, function(item, key){
            var item = {
                value: item.number_of_items,
                label: key,
                color: color_array[counter_type]
            }
            counter_type++;
            if(counter_type > color_array.length){
                counter_type = 0;
            }
            data_type.push(item);
        });

        var data = {
            dataDep: data_dep,
            dataLoc: data_loc,
            dataType: data_type
        }

        return data;
    },
    listPieData: function(item, key) {
        return (
            <tr key={key}>
                <td>{item.label}</td>
                <td className="text-right">{numberWithCommas(item.value)} stk.</td>
            </tr>
        );
    },
    render: function() {
        var chartData = {}
        var pieData= {}
        if(!_.isEmpty(this.state.reportList) && !_.isEmpty(this.state.items)){
            chartData = this.constructChartData();
            pieData = this.constructPieData();
        }

        var total_users = 0;
        var total_items = 0;
        var total_price = 0;
        var total_price_digits = 0;
        var total_price_label = " kr.";
        var total_cost = 0;
        var total_cost_digits = 0;
        var total_cost_label = " kr.";

        if(!_.isEmpty(this.state.reportList) && this.state.reportList.users_in_account){
            total_users = this.state.reportList.users_in_account;
            total_items = this.state.reportList.total_number_of_items;
            total_price = this.state.reportList.total_purchase_price;
            if(total_price > 999){
                total_price = total_price/1000;
                total_price_label = " þús.kr.";
            }
            if(total_price > 999999){
                total_price = total_price/1000000;
                total_price_label = " M.kr.";
                total_price_digits = 1;
            }
            total_cost = this.state.reportList.total_internal_cost;
            if(total_cost > 999){
                total_cost = total_cost/1000;
                total_cost_label = " þús.kr.";
            }
            if(total_cost > 999999){
                total_cost = total_cost/1000000;
                total_cost_label = " M.kr.";
                total_cost_digits = 1;
            }
        }
        return (
            <div className="content_section">
                <div id="subheader">
                    <h1 className="subheader-title">Yfirlit</h1>
                </div>
                {(this.state.fetchingItems) ?
                    <Spinner name='three-bounce'/> :
                    <div>
                        {(AuthenticationStore.getState().is_staff) ?
                            <div className="statistics">
                                {(_.isEmpty(this.state.items)) ?
                                    <div className="empty-list">
                                      <h2>Ekkert yfirlit til</h2>
                                      <p>Bættu búnaði í <Link to="/inventory"><strong>búnaðarskrána</strong></Link> þína til að sjá tölfræði.</p>
                                      <i className="fal fa-align-slash"></i>
                                    </div> :
                                    <div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="stat-box">
                                                    <span>{total_users}</span>
                                                    <div className="stat-label">Fjöldi notenda</div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="stat-box">
                                                    <span>{total_items}</span>
                                                    <div className="stat-label">Búnaður á skrá</div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="stat-box">
                                                    <span>{total_price.toFixed(total_price_digits)}</span>
                                                    <span className="stat-box-affix">{total_price_label}</span>
                                                    <div className="stat-label">Innkaupsverð búnaðar</div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="stat-box">
                                                    <span>{total_cost.toFixed(total_cost_digits)}</span>
                                                    <span className="stat-box-affix">{total_cost_label}</span>
                                                    <div className="stat-label">Innri kostnaður</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="item-chart">
                                            {(!_.isEmpty(chartData)) &&
                                                <LineChart data={chartData} options={chartOptions} width="1270px" height="250"/>
                                            }
                                            </div>
                                        </div>
                                        <div className="row">
                                            {(!_.isEmpty(pieData)) &&
                                            <div className="item-chart">
                                                <div className="col-md-4">
                                                    <div className="pie-container text-center">
                                                        <h3>Deildir</h3>
                                                        <h4><small>Búnaður eftir deildum</small></h4>
                                                        <DoughnutChart data={pieData.dataDep} width="250px" height="250" />
                                                    </div>
                                                    <table className="table table-condensed">
                                                        <tbody>
                                                            {_.map(pieData.dataDep, this.listPieData)}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="pie-container text-center">
                                                        <h3>Staðsetningar</h3>
                                                        <h4><small>Búnaður eftir staðsetningu</small></h4>
                                                        <DoughnutChart data={pieData.dataLoc} width="250px" height="250" />
                                                    </div>
                                                    <table className="table table-condensed">
                                                        <tbody>
                                                            {_.map(pieData.dataLoc, this.listPieData)}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="pie-container text-center">
                                                        <h3>Tegundir</h3>
                                                        <h4><small>Búnaður eftir tegundum</small></h4>
                                                        <DoughnutChart data={pieData.dataType} width="250px" height="250" />
                                                    </div>
                                                    <table className="table table-condensed">
                                                        <tbody>
                                                            {_.map(pieData.dataType, this.listPieData)}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div> :
                            <div className="text-center">
                                <h2>
                                    Þú hefur ekki aðgang að þessum hluta kerfisins.
                                </h2>
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }
});


module.exports = Reports;



// WEBPACK FOOTER //
// ./app/scripts/ui/Reports/Reports.react.js